import React, { useContext, useEffect,useState,useRef } from 'react'
import { isMobile } from 'react-device-detect';
import { LanguageContext } from '../../context'
import { getItemVal } from '../../Data/GeneralFanction';
import { getAll } from '../../Data/Utils';
import Translate from '../Translate/Translate';
import "./IframeShow.css"

const IframeShow = ({tab,dataSet}) => {
  

  const [loader,SetLoader]=useState('');
  const {language} =useContext(LanguageContext);
  const refH=useRef(null);


  useEffect(()=>{  
    //var elm= document.getElementsByClassName("iframe-main title");
    var elm= document.getElementsByClassName("iframe-main");
    if(elm.length>0){
      // var tElm=elm.getElementsByTagName("h1");
      // if(tElm.length>0){
      //   //tElm.att
      // }
    }
  },[loader]);

  window.onmessage = function(e) {
    if (e.data == 'exitIframe') {
 
        refH.current.closest(".data-item-container").nextElementSibling.focus();
    }
};
  

  // const FixedUrl=(fieldName,isMap=false)=>{
  //   let url =getItemVal(fieldName,dataSet);
  //   if(url==null)
  //     return "";
  //   if(url.indexOf('/')==0)
  //     url=window.srcSiteUrl+url;
  //     if(isMap){
  //       url=url.toLowerCase().replace("/index.aspx","/index.mobile.aspx");
  //     }
  //   return url;

  // }

  const FixedUrl=(fieldName)=>{
    let url =getItemVal(fieldName,dataSet);
    if(url==null)
      return "";
    if(url.indexOf('/')==0)
      url=window.srcSiteUrl+url;
     
    return url;

  }

  const hendlerLoad=(event)=>{
    SetLoader("loader")

    window.setTimeout(() => {
      if (document.activeElement === event.currentTarget) {
        event.currentTarget.blur();
        refH.current?.focus();
      }
    }, 0);
  }

 

  // const handlerBlur=()=>{
  //   alert("i come back");
  // }

  return (
    <div className={tab.label.en}>
      
    <h2 ref={refH} tabIndex="-1">{tab.label[language]}</h2>
        <div className="info" >
         {tab.dataItem!=undefined && FixedUrl(tab.dataItem.fieldName[language])!="" && <a href={FixedUrl(tab.dataItem.fieldName[language])} target="_blank" ><Translate>{tab.dataItem.desc}</Translate></a>}
      
{tab.icon=="analytic" &&
<>
             <Translate>AccessibilityGuidelines</Translate><br/>
                      <a href="https://docs.microsoft.com/he-il/power-bi/desktop-accessibility-keyboard-shortcuts"><Translate>InstructionsNavigation</Translate></a><br />
                      <a href="https://docs.microsoft.com/he-il/power-bi/create-reports/desktop-accessibility-consuming-tools"><Translate>InfoAccessibility</Translate></a><br />
                      <br /></>
  }

        </div>
        {/* <div className='divIframe' dangerouslySetInnerHTML={{__html: pageData}} /> */}
        <div  className={`img_Loading_Sand ${loader}`}></div>
          {/* <iframe src={tab.icon=="map"?`${FixedUrl(tab.field[language],isMobile?true:false)}&embed=y`:FixedUrl(tab.field[language])} width='100%' height='850px' allowFullScreen loading='lazy' title={tab.titleIframe[language]} onLoad={hendlerLoad} class="iframe-main" /> */}
          
<iframe src={tab.icon=="map"?`${FixedUrl(tab.field[language])}&embed=y`:FixedUrl(tab.field[language])} width='100%' height='850px' allowFullScreen loading='lazy' title={tab.titleIframe[language]} onLoad={hendlerLoad} className="iframe-main" />          
          
       
    </div>
    
  )
}

export default IframeShow